<template>
<div id="app">
    <div v-if="isAppConsole">
        <main>
            <router-view v-lcs />
        </main>
    </div>
    <template v-else>
        <app-header ref="header" />
        <app-sidebar />
        <main>
            <router-view v-lcs />
            <app-footer />
        </main>
        <app-dialog />
        <app-tooltip />
    </template>
    <snackbar :options.sync="snackbar" />
</div>
</template>

<script>
import AppHeader from "@/components/layouts/header/AppHeader.vue";
import AppFooter from "@/components/layouts/footer/AppFooter.vue";
import AppSidebar from "@/components/layouts/sidebar/AppSidebar.vue";
import AppDialog from "@/components/AppDialog.vue";
import AppTooltip from "@/components/AppTooltip";
import Snackbar from "@/components/mdc/Snackbar.vue";
import { mapGetters } from "vuex";
import newsMixin from "@/components/dialogs/news/news.mixin";

export default {
    components: {
        AppHeader,
        AppFooter,
        AppSidebar,
        AppDialog,
        AppTooltip,
        Snackbar
    },
    mixins: [newsMixin],
    computed: {
        ...mapGetters(["isSidebarOpen", "isLoggedIn"]),
        snackbar: {
            get() {
                return this.$store.state.snackbar.snackbar;
            },
            set(value) {
                this.$store.commit("snackbar.SET_MESSAGE", {
                    key: "snackbar",
                    value
                });
            }
        },
        isAppConsole() {
            return location.pathname === "/app_console";
        }
    },
    watch: {
        isSidebarOpen(open) {
            if (open) document.body.classList.add("mdc-dialog-scroll-lock");
            else document.body.classList.remove("mdc-dialog-scroll-lock");
        }
    },
    mounted() {
        if (this.isInNewsPeriod && !this.isNewsChecked) {
            this.openNewsDialog();
            this.setNewsChecked();
        }
    }
};
</script>
